import type { ReactNode } from 'react'

import { CardButton, type TCardButtonProps } from '@/src/elements/button/card/CardButton'
import { ICON } from '@/src/general/enums/icons'

export type TRadioButtonProps = Omit<TCardButtonProps, 'startIcon' | 'endIcon' | 'role' | 'aria-checked'> & {
  icon?: ICON
}

export const RadioButton = ({ icon, selected = false, ...cardButtonProps }: TRadioButtonProps): ReactNode => (
  <CardButton
    {...cardButtonProps}
    startIcon={icon}
    endIcon={selected ? ICON.RADIO_ON : ICON.RADIO_OFF}
    selected={selected}
    role="radio"
    aria-checked={selected}
  />
)
